module.exports = __webpack_public_path__ + "images/c68ef2ba69e74a743c10d2f928fd9527-kitchen_bespoke.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content/kitchen_bespoke.jpg
// module id = ./src/assets/images/content/kitchen_bespoke.jpg
// module chunks = 0